import { createSelector } from 'reselect'
import shouldShowTemporaryUnlockedSamplesBannerSelect from 'modules/temporary-unlocked-samples/redux/selectors/should-show'
import getPaddingTopSquadSelectorUtil from 'pages/Squad/selectors/get-padding-top/utils'
import shouldShowFastTrackExpiryBannerLoyaltySelect from 'modules/loyalty/redux/selectors/should-show-fast-track-expiry-banner'
import shouldShowBannerPostSampleSurveySelect from 'modules/post-sample-survey/redux/selectors/should-show-banner'

const getPaddingTopSquadSelector = (isMediumScreen) => createSelector(
  shouldShowBannerPostSampleSurveySelect,
  shouldShowTemporaryUnlockedSamplesBannerSelect,
  shouldShowFastTrackExpiryBannerLoyaltySelect,
  (shouldShowPostSampleBanner, shouldShowTemporaryUnlockedSamplesBanner, shouldShowFastTrackExpiryBanner) => {
    return getPaddingTopSquadSelectorUtil({
      shouldShowPostSampleBanner,
      shouldShowTemporaryUnlockedSamplesBanner,
      shouldShowFastTrackExpiryBanner,
      isMediumScreen
    })
  }
)

export default getPaddingTopSquadSelector
